import { DISCOUNT_TYPES, type TierUsageData } from '@weft/types';
import { isNullOrUndefined } from '@weft/utils';

export function getTierUsagePrice(tierUsageData: TierUsageData, initialPrice: number): number {
  if (isNullOrUndefined(tierUsageData.discountConfiguration)) {
    return initialPrice;
  }

  const { amount, type } = tierUsageData.discountConfiguration;

  return type === DISCOUNT_TYPES.Fixed
    ? amount
    : initialPrice - amount * initialPrice / 100;
}